import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import About from '../pages/About.vue'
import List from '../pages/List.vue'
import Edit from '../pages/Edit.vue'
import Stats from '../pages/Stats.vue'
import Project from '../pages/Project.vue'
import Contact from '../pages/Contact.vue'
import Terms from '../pages/Terms.vue'



Vue.use(VueRouter)
	const routes: Array<RouteConfig> = [
	{
		path: '/',
		name: 'home',
		component: About
	},
	{
		path: '/list',
		name: 'list',
		component: List
	},
	{
		path: '/edit/:id',
		name: 'edit',
		component: Edit
	},
	{
		path: '/stats/:id',
		name: 'stats',
		component: Stats
	},
	{
		path: '/project/:alias',
		name: 'project',
		component: Project
	},
	{
		path: '/contact',
		name: 'contact',
		component: Contact
	},
	{
		path: '/terms',
		name: 'terms',
		component: Terms
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
